<!--  Created by   : Ankush Bhardwaj                                                             -->
<!--  Create Dated : 02-FEB-2022                                                              -->
<!--  Purpose      : Online Application Form for Nominating Authority and Nominee                                    -->
<template>
  <div id="divApplication">
    <transition>
      <div class="Flex_Table tblEntryForm">
        <div class="Flex_Row">
          <fieldset class="EntryBlock" style="width: 100%">
            <legend style="background-color: transparent !important">
              <div class="Flex_Table tblEntryForm">
                <div
                  class="Flex_Row"
                  style="margin-left: -5px; margin-bottom: -2px"
                >
                  <div
                    class="Flex_Cell_Inline"
                    v-show="(userTypeID == 1 || userTypeID == 4) && Nomination_List.length > 0"
                  >
                    <span
                      :class="selectTab1 ? 'tabSelectClass' : 'tabClass'"
                      v-on:click="tabClick(1)"
                    >
                      SUBMITTED NOMINATIONS
                    </span>
                  </div>
                  <div class="Flex_Cell_Inline" v-show="userTypeID == 1 || userTypeID == 4">
                    <span
                      :class="selectTab2 ? 'tabSelectClass' : 'tabClass'"
                      v-on:click="tabClick(2)"
                    >
                      NOMINATING AUTHORITY
                    </span>
                  </div>
                  <div class="Flex_Cell_Inline">
                    <span
                      :class="selectTab3 ? 'tabSelectClass' : 'tabClass'"
                      v-on:click="tabClick(3)"
                    >
                      NOMINEE DETAILS
                    </span>
                  </div>
                  <div class="Flex_Cell_Inline" v-if="PayNomAuthID != -1">
                    <span
                      :class="selectTab4 ? 'tabSelectClass' : 'tabClass'"
                      v-on:click="tabClick(4)"
                    >
                      PAYMENT OPTION
                    </span>
                  </div>
                  <div class="Flex_Cell_Inline" v-if="isFeeInvoice">
                    <span
                      :class="selectTab5 ? 'tabSelectClass' : 'tabClass'"
                      v-on:click="tabClick(5)"
                    >
                      Fee Receipt
                    </span>
                  </div>
                </div>
              </div>
            </legend>
            <div
              style="width: 100%"
              v-if="(userTypeID == 1 || userTypeID == 4) && selectTab1 && Nomination_List.length > 0"
            >
              <div class="Flex_Table tblEntryForm">
                <div class="Flex_Row">
                  <div class="Flex_Cell" style="padding-right: 10px">
                    <fieldset>
                      <legend>NOMINATING AUTHORITY LIST</legend>
                      <div class="Flex_Table ekkGrid">
                        <div class="Flex_Row GridHeader">
                          <div
                            class="Flex_Cell"
                            align="left"
                            style="width: 18%"
                          >
                            Ref. No.
                          </div>
                          <div
                            class="Flex_Cell"
                            align="left"
                            style="width: 23%"
                          >
                            Bank Name
                          </div>
                          <div
                            class="Flex_Cell"
                            align="left"
                            style="width: 15%"
                          >
                            Branch/Department
                          </div>
                          <div
                            class="Flex_Cell"
                            align="left"
                            style="width: 15%"
                          >
                            Name
                          </div>
                          <div
                            class="Flex_Cell"
                            align="center"
                            style="width: 5%"
                          >
                            Edit
                          </div>
                          <div
                            class="Flex_Cell"
                            align="center"
                            style="width: 8%"
                          >
                            Add Nominee
                          </div>
                          <div class="Flex_Cell" align="center">
                            Payment Option
                          </div>
                        </div>
                        <div
                          class="Flex_Table"
                          align="center"
                          v-for="(row, index) in Nomination_List"
                          :key="index"
                        >
                          <div
                            class="Flex_Row GridContent"
                            valign="middle"
                            style="cursor: pointer;
                              border-bottom: solid 1px;
                              background-color: bisque;
                            "
                            @click="ForSliderBottom(index)"
                          >
                            <div
                              class="Flex_Cell"
                              align="left"
                              title="Nominating Authority Reference No."
                              style="width: 18%; border-right: solid 1px"
                            >
                              <!-- <img
                                :id="'sliderImg' + index"
                                src="../assets/images/arrow_bottom.png"
                              /> -->
                              {{ row.nominationCode }}
                            </div>
                            <div
                              class="Flex_Cell"
                              align="left"
                              style="width: 23%; border-right: solid 1px"
                            >
                              {{ row.bankName }}
                            </div>
                            <div
                              class="Flex_Cell"
                              align="left"
                              style="width: 15%; border-right: solid 1px"
                            >
                              {{ row.branchName }}
                            </div>
                            <div
                              class="Flex_Cell"
                              align="left"
                              style="width: 15%; border-right: solid 1px"
                            >
                              {{ row.title }} {{ row.firstName }}
                              {{ row.middleName }}
                              {{ row.surName }}
                            </div>
                            <div
                              class="Flex_Cell"
                              align="center"
                              style="width: 5%; border-right: solid 1px"
                            >
                              <b>
                                <span
                                  class="glyphicons edit"
                                  style="cursor: pointer"
                                  title="Edit"
                                  v-on:click="tabClick(2, row)"
                                ></span>
                              </b>
                            </div>
                            <div
                              class="Flex_Cell"
                              align="center"
                              style="width: 8%; border-right: solid 1px"
                            >
                              <b>
                                <span
                                  class="glyphicons circle_plus"
                                  style="cursor: pointer"
                                  title="Add Nominee"
                                  v-on:click="tabclickAddNominee(row)"
                                ></span>
                              </b>
                            </div>
                            <div
                              class="Flex_Cell"
                              align="center"
                              style="border-right: solid 1px"
                            >
                              <input
                                type="button"
                                id="btnPay"
                                name="btnPay"
                                btnName="btnPay"
                                value="Proceed to Pay"
                                style="padding: 5px 15px 5px 15px"
                                title="Click here to Payment Option"
                                @click="tabClick(4, row)"
                                v-if="
                                  Candidate_List.filter((item) => {
                                    return item.nomineeID == row.nomineeID;
                                  }).length > 0 &&
                                  (userTypeID == 1 || userTypeID == 2 || userTypeID == 4) &&
                                  (row.onlinePaymentStatus == 0 ||
                                    row.onlinePaymentStatus == 2)
                                "
                              />
                              <input
                                type="button"
                                id="btnRetryPay"
                                name="btnRetryPay"
                                btnName="btnRetryPay"
                                style="
                                  padding: 5px 15px 5px 15px;
                                  background-color: red;
                                "
                                value="Update Payment Status"
                                title="If Your payment has been deducted but payment reciept has not been generated than Click here to Update Payment Status..! "
                                @click="RetryPayment(row.nomineeID)"
                                v-if="
                                  Candidate_List.filter((item) => {
                                    return item.nomineeID == row.nomineeID;
                                  }).length > 0 &&
                                  (userTypeID == 1 || userTypeID == 4) &&
                                  row.paymentMode == 1 &&
                                  row.onlinePaymentStatus == 0
                                "
                              />
                              <input
                                type="button"
                                v-if="
                                  (userTypeID == 1 || userTypeID == 4) &&
                                  row.onlinePaymentStatus == 1
                                "
                                style="
                                  padding: 5px 20px;
                                  margin-left: 10px;
                                  background-color: #f7b408 !important;
                                  color: black !important;
                                "
                                id="btnPaid"
                                name="btnPaid"
                                btnName="btnPaid"
                                value="Paid"
                                @click="tabClick(4, row)"
                              />
                            </div>
                          </div>
                          <div
                            class="Flex_Row"
                            style="margin-left: 40px"
                            v-if="
                              Candidate_List.filter((item) => {
                                return item.nomineeID == row.nomineeID;
                              }).length > 0
                            "
                          >
                            <div
                              class="Flex_Table ekkGrid"
                              style="margin-right: 40px"
                              :id="'grid' + index"
                            >
                              <div
                                class="Flex_Row GridHeader"
                                style="background-color: #4682b4"
                              >
                                <div
                                  class="Flex_Cell"
                                  align="left"
                                  style="width: 17%"
                                >
                                  Ref No.
                                </div>
                                <div
                                  class="Flex_Cell"
                                  align="left"
                                  style="width: 17%"
                                >
                                  Nominee Name
                                </div>
                                <div
                                  class="Flex_Cell"
                                  align="left"
                                  style="width: 17%"
                                >
                                  Designation
                                </div>
                                <div class="Flex_Cell" style="width: 15%">
                                  Mobile No. (WhatsApp No.)
                                </div>
                                <div
                                  class="Flex_Cell"
                                  align="left"
                                  style="width: 19%"
                                >
                                  Email
                                </div>
                                <div class="Flex_Cell" style="width: 10%">
                                  Is Cancelled
                                </div>
                                <div class="Flex_Cell">Edit</div>
                              </div>
                              <div
                                class="Flex_Row GridContent"
                                valign="middle"
                                v-for="(row1, index1) in Candidate_List.filter(
                                  (item) => {
                                    return item.nomineeID == row.nomineeID;
                                  }
                                )"
                                :key="index1"
                              >
                                <div
                                  class="Flex_Cell"
                                  title="Nominee Reference No."
                                  align="left"
                                  style="width: 17%"
                                >
                                  {{ row1.candGRNo }}
                                </div>
                                <div
                                  class="Flex_Cell"
                                  style="width: 17%"
                                  align="left"
                                >
                                  {{ row1.title }} {{ row1.firstName }}
                                  {{ row1.middleName }}
                                  {{ row1.surName }}
                                </div>
                                <div
                                  class="Flex_Cell"
                                  style="width: 17%"
                                  align="left"
                                >
                                  {{ row1.desigName }}
                                </div>
                                <div class="Flex_Cell" style="width: 15%">
                                  {{ row1.curMobile }}
                                </div>
                                <div
                                  class="Flex_Cell"
                                  style="width: 19%"
                                  align="left"
                                >
                                  {{ row1.email }}
                                </div>
                                <div class="Flex_Cell" style="width: 10%">
                                  <span v-if="row1.isCancel == false">No</span>
                                  <span v-if="row1.isCancel == true">Yes</span>
                                </div>
                                <div class="Flex_Cell" align="center">
                                  <b>
                                    <span
                                      class="glyphicons edit"
                                      style="cursor: pointer"
                                      title="Edit"
                                      v-on:click="tabClick(3, row1)"
                                    ></span>
                                  </b>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
            <div class="Flex_Table" v-if="(userTypeID == 1 || userTypeID == 4) && selectTab2">
              <div class="Flex_Row">
                <div class="Flex_Cell">
                  <nom-auth-form
                    ref="tab2"
                    :userTypeID="userTypeID"
                    :TitleList="title_List"
                    :ProgID="progID"
                    :ModeOfExecution="programmeModeOfExecution"
                    :NomAuthList="selectedNomAuthData"
                    :NomAuthID="nominatingAuthID"
                    :NominationCode="nominationCode"
                    :PaymentStatus="paymentStatus"
                    style="border: none"
                    @AddORUpdateNomAuth="addORUpdateNomAuth($event)"
                    @ChangeNomAuthID="changeNomAuthID($event)"
                    @ChangeNominationCode="changeNominationCode($event)"
                  ></nom-auth-form>
                </div>
              </div>
            </div>
            <div
              class="Flex_Table"
              v-if="
                (userTypeID == 1 || userTypeID == 4 || userTypeID == 2 || userTypeID == 3) &&
                selectTab3
              "
            >
              <div class="Flex_Row">
                <div class="Flex_Cell">
                  <nom-details-form
                    ref="tab3"
                    :NomAuthID="nominatingAuthID"
                    :NominationCode="nominationCode"
                    :CandidateData="selectedNomData"
                    :userTypeID="userTypeID"
                    :TitleList="title_List"
                    :ProgID="progID"
                    :PaymentStatus="paymentStatus"
                    :PaymentMode="paymentMode"
                    :ModeOfExecution="programmeModeOfExecution"
                    :key="userTypeID"
                    @AddORUpdateNomAuth="addORUpdateNomAuth($event)"
                    @IsClear="IsSelectedCandDataClear($event)"
                    @ChangeNomAuthIDForPayment="
                      changeNomAuthIDForPayment($event)
                    "
                    @ChangeNomAuthDetails="ChangeNomAuthDetails($event)"
                    style="border: none"
                  ></nom-details-form>
                  <!-- @ChangeNomAuthID="changeNomAuthIDForPayment($event)" -->
                </div>
              </div>
            </div>
            <div
              class="Flex_Table"
              v-if="(userTypeID == 1 || userTypeID == 4 || userTypeID == 2) && selectTab4"
            >
              <div class="Flex_Row">
                <div class="Flex_Cell">
                  <payment-option-form
                    ref="tab4"
                    :userTypeID="userTypeID"
                    :ProgID="progID"
                    :NomAuthID="PayNomAuthID"
                    :NominationCode="nominationCode"
                    :FinYearID="finYearID"
                    :PaymentStatus="paymentStatus"
                    :PaymentMode="paymentMode"
                    :IsApproved="isApproved"
                    style="border: none"
                  ></payment-option-form>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </transition>
    <transition name="fade"> </transition>
    <div class="backgroundPopup" v-if="showBackGround"></div>
  </div>
</template>
<script>
import AcceptInput from "./ekkControls/AcceptInput.vue";
import DateControl from "./ekkControls/DateControl.vue";
import SearchDropDown from "./ekkControls/SearchDropDown.vue";
import CheckDropDown from "./ekkControls/CheckDropDown.vue";
import BlockInput from "./ekkControls/BlockInput.vue";
import Tab from "./ekkControls/Tab.vue";
import OnOff from "./ekkControls/OnOff.vue";
import NomAuthForm from "./NominatingAuth.vue";
import NomDetailsForm from "./NomineeDetails.vue";
import PaymentOptionForm from "./PaymentOption.vue";
import HomeJS from "./serviceJS/homeJS.js";
import AppJS from "./serviceJS/applicationJS.js";
import NomAuthJS from "./serviceJS/NomineeAuth.js";
import NomDetailsJS from "./serviceJS/NomineeDetails.js";
import PaymentJS from "./serviceJS/paymentJS.js";
// Import AcceptInput libraries from "./ekkControls/AcceptInput" for using the Custom made vue for AcceptInput for (restriction of inputing)
export default {
  name: "Application",
  components: {
    DateControl: DateControl,
    AcceptInput: AcceptInput,
    SearchDropDown: SearchDropDown,
    CheckDropDown: CheckDropDown,
    Tab: Tab,
    BlockInput: BlockInput,
    OnOff: OnOff,
    "nom-auth-form": NomAuthForm,
    "nom-details-form": NomDetailsForm,
    "payment-option-form": PaymentOptionForm,
  },
  data() {
    return {
      showBackGround: false,
      selectTab1: false,
      selectTab2: false,
      selectTab3: false,
      selectTab4: false,
      userTypeID: -1,
      progID: -1,
      progCode: "",
      programmeModeOfExecution: -1,
      title_List: [],
      nominatingAuthID: -1,
      nominationCode: -1,
      Nomination_List: [],
      NomAuthName: "",
      selectedNomAuthData: [],
      selectedNomData: [],
      Candidate_List: [],
      PayNomAuthID: -1,
      finYearID: -1,
      paymentStatus: -1,
      paymentMode: -1,
      isFeeInvoice: false,
      isApproved: -1,
    };
  },
  methods: {
    ForSliderBottom(index) {
      $("#grid" + index).slideToggle(350);
      // let img = document.getElementById("sliderImg" + index);
      // let imgScr =
    },
    addORUpdateNomAuth(e) {
      this.GetOnlineNominee(e, 3);
    },
    changeNomAuthID(e) {
      this.nominatingAuthID = e;
    },
    changeNominationCode(e) {
      this.nominationCode = e;
    },
    changeNomAuthIDForPayment(e) {
      this.PayNomAuthID = e;
      this.tabClick(4);
    },
    ChangeNomAuthDetails(e) {
      this.tabClick(4, e);
    },
    IsSelectedCandDataClear(e) {
      if (e == true) {
        this.selectedNomData = [];
        this.nominatingAuthID = -1;
      }
    },
    tabclickAddNominee(row) {
      if (row != null) {
        this.selectedNomAuthData = this.Nomination_List.filter((item) => {
          return item.nomineeID == row.nomineeID;
        });
        this.nominatingAuthID = this.Nomination_List.filter((item) => {
          return item.nomineeID == row.nomineeID;
        })[0].nomineeID;
        this.nominationCode = this.Nomination_List.filter((item) => {
          return item.nomineeID == row.nomineeID;
        })[0].nominationCode;
        this.paymentStatus = this.Nomination_List.filter((item) => {
          return item.nomineeID == row.nomineeID;
        })[0].onlinePaymentStatus;
        this.paymentMode = this.Nomination_List.filter((item) => {
          return item.nomineeID == row.nomineeID;
        })[0].paymentMode;
      }
      this.selectTab1 = false;
      this.selectTab2 = false;
      this.selectTab3 = true;
      this.selectTab4 = false;
    },
    tabClick(type, row) {
      if (type == 1) {
        this.selectTab1 = true;
        this.selectTab2 = false;
        this.selectTab3 = false;
        this.selectTab4 = false;
      } else if (type == 2) {
        if (row != null) {
          this.selectedNomAuthData = this.Nomination_List.filter((item) => {
            return item.nomineeID == row.nomineeID;
          });
          this.nominatingAuthID = this.Nomination_List.filter((item) => {
            return item.nomineeID == row.nomineeID;
          })[0].nomineeID;
          this.nominationCode = this.Nomination_List.filter((item) => {
            return item.nomineeID == row.nomineeID;
          })[0].nominationCode;
          this.NomAuthName = this.Nomination_List.filter((item) => {
            return item.nomineeID == row.nomineeID;
          })[0].bankName;
          this.paymentStatus = this.Nomination_List.filter((item) => {
            return item.nomineeID == row.nomineeID;
          })[0].onlinePaymentStatus;
          this.paymentMode = this.Nomination_List.filter((item) => {
            return item.nomineeID == row.nomineeID;
          })[0].paymentMode;
        }
        this.selectTab1 = false;
        this.selectTab2 = true;
        this.selectTab3 = false;
        this.selectTab4 = false;
      } else if (type == 3) {
        // console.log(row);
        this.selectTab1 = false;
        this.selectTab2 = false;
        this.selectTab4 = false;
        if (row != null) {
          this.selectedNomAuthData = this.Nomination_List.filter((item) => {
            return item.nomineeID == row.nomineeID;
          });
          this.selectedNomData = this.Candidate_List.filter((item) => {
            return item.candidateID == row.candidateID;
          });
          this.nominatingAuthID = this.Candidate_List.filter((item) => {
            return item.candidateID == row.candidateID;
          })[0].nomineeID;
          this.nominationCode = this.Candidate_List.filter((item) => {
            return item.candidateID == row.candidateID;
          })[0].nominationCode;
          this.paymentMode = this.Candidate_List.filter((item) => {
            return item.candidateID == row.candidateID;
          })[0].paymentMode;
          this.$nextTick(() => {
            this.paymentStatus = this.Candidate_List.filter((item) => {
              return item.candidateID == row.candidateID;
            })[0].onlinePaymentStatus;
          });
        }
        this.selectTab3 = true;
      } else if (type == 4) {
        if (row != null) {
          this.selectedNomAuthData = this.Nomination_List.filter((item) => {
            return item.nomineeID == row.nomineeID;
          });
          // console.log(this.selectedNomAuthData);
          this.nominatingAuthID = this.Nomination_List.filter((item) => {
            return item.nomineeID == row.nomineeID;
          })[0].nomineeID;
          this.nominationCode = this.Nomination_List.filter((item) => {
            return item.nomineeID == row.nomineeID;
          })[0].nominationCode;
          this.paymentStatus = this.Nomination_List.filter((item) => {
            return item.nomineeID == row.nomineeID;
          })[0].onlinePaymentStatus;
          this.paymentMode = this.Nomination_List.filter((item) => {
            return item.nomineeID == row.nomineeID;
          })[0].paymentMode;
          this.PayNomAuthID = this.Nomination_List.filter((item) => {
            return item.nomineeID == row.nomineeID;
          })[0].nomineeID;
          this.nominationCode = this.Nomination_List.filter((item) => {
            return item.nomineeID == row.nomineeID;
          })[0].nominationCode;
          this.isApproved = this.Nomination_List.filter((item) => {
            return item.nomineeID == row.nomineeID;
          })[0].isApproved;
        }
        this.selectTab1 = false;
        this.selectTab2 = false;
        this.selectTab3 = false;
        this.selectTab4 = true;
      }
    },
    GetOnlineNominee(progID, tab) {
      const _data_ = { progID: progID, nomineeID: -1, type: 1 };
      NomAuthJS.GetOnlineNominee(_data_).then(
        (response) => {
          if (response.data.length > 0) {
            this.Nomination_List = response.data;
            this.GetCandidate(
              this.Nomination_List.filter((item) => {
                return item.progID == this.progID;
              })
            );
            this.tabClick(1);
            if (tab == 3) {
              this.tabClick(tab);
            }
          } else {
            this.tabClick(2);
            if (this.userTypeID == 3 || this.userTypeID == 2) {
              this.GetCandidate();
            }
            // this.nominatingAuthID = -1;
            // this.nominationCode = -1;
          }
        },
        (error) => {}
      );
    },
    GetCandidate(row) {
      let Type = 1;
      if (this.userTypeID == 1 || this.userTypeID == 4) {
        Type = 1;
      } else {
        Type = 2;
      }
      let nomineeID = -1;
      if (row != undefined) {
        if (this.userTypeID == 2 && row.length > 0) {
          nomineeID = row[0].nomineeID;
        }
      }
      let _param = {
        NomineeID: nomineeID,
        CandidateID: -1,
        ProgID: this.progID,
        UserTypeID: this.userTypeID,
        Type: Type,
      };
      NomDetailsJS.GetNominee(_param).then((response) => {
        if (response.data.length > 0) {
          this.Candidate_List = response.data.filter((item) => {
            return item.progID == this.progID;
          });
          // console.log(this.Candidate_List);
          // this.Candidate_List = response.data;
          if (this.userTypeID != 1 && this.userTypeID != 4) {
            this.tabClick(3, this.Candidate_List[0]);
          }
        } else {
          if (this.userTypeID == 1 || this.userTypeID == 4) {
            this.tabClick(1);
          } else {
            this.tabClick(3);
          }
        }
      });
      //}
    },
    fillUserData() {
      this.GetTitle();
      HomeJS.GetCurrentUser().then(
        (response) => {
          if (response.data) {
            this.userTypeID = response.data.loginUser.userTypeID;
            // console.log("User Type ID " + this.userTypeID);
            this.GetOnlineNominee(this.progID);
          }
        },
        (error) => {}
      );
    },
    GetTitle() {
      AppJS.GetTitle().then(
        (response) => {
          if (response.data) {
            this.title_List = response.data;
            // this.GetDesig();
          }
        },
        (error) => {}
      );
    },
    GetDesig() {
      const _data_ = { DesigID: -1, type: 1 };
      AppJS.GetDesig(_data_).then(
        (response) => {
          if (response.data) {
            // this.desig_list = response.data;
          }
        },
        (error) => {}
      );
    },
    paymentOption() {},
    showMessageBoxPaymentOption() {
      MessageBox.show(
        {
          message: "Are you sure to Pay?",
          type: "confirm",
          title: "",
          defaultButton: 3,
        },
        {
          buttonName: "Yes",
          buttonAction: this.paymentOption,
        },
        { buttonName: "Cancel", buttonAction: this.clear }
      );
    },
    RetryPayment(nomineeID) {
      const _data = {
        NomineeID: nomineeID,
        Type: 1,
      };
      PaymentJS.GetListFailedTransactions(_data).then(
        (response) => {
          console.log(response.data);
          if (response.data[0].isSuccess) {
            MessageBox.show({
              message: response.data[0].msg,
              type: "success",
              title: "Success",
            });
            this.fillUserData();
          } else {
            MessageBox.show({
              message: response.data[0].msg,
              type: "error",
              title: "Error",
            });
          }
        },
        (error) => {},
        (failure) => {}
      );
    },
  },
  computed: {},
  watch: {},
  mounted() {
    if (
      this.$root.$data.ProgID != undefined &&
      this.$root.$data.ProgModeOfExec != undefined &&
      this.$root.$data.ProgCode != undefined &&
      this.$root.$data.FinYearID != undefined
    ) {
      this.progID = this.$root.$data.ProgID;
      this.programmeModeOfExecution = this.$root.$data.ProgModeOfExec;
      this.ProgCode = this.$root.$data.ProgCode;
      this.finYearID = this.$root.$data.FinYearID;
      this.fillUserData();
    } else {
      this.$router.push({ name: "Home" });
    }
  },
  //beforeRouteEnter(to, from, next) {},
};
</script>
<style scoped>
.instruction {
  background: #37758814;
  padding: 1px 16px;
  margin-left: 0;
  margin-right: 0;
  border-left: #03a9f475 solid 10px;
  border-radius: 5px;
  min-height: 30px;
  line-height: 30px;
  font-size: medium;
  margin-bottom: 6px;
  border-bottom: solid thin darkgrey;
}
.payinstruction {
  background: #37758814;
  padding: 1px 16px;
  margin-left: 0;
  margin-right: 0;
  border-left: #03a9f475 solid 5px;
  border-radius: 5px;
  min-height: 20px;
  line-height: 20px;
  font-size: inherit;
  margin-bottom: 6px;
  /* border-bottom: solid thin darkgrey; */
}
.tabClass {
  padding: 5px 8px;
  margin-right: 3px;
  font-size: medium;
  border: solid 1px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  font-family: consolas;
  cursor: pointer;
  border-right: solid 2px black;
  box-shadow: 3px 1px 4px;
  background-color: white;
  color: Black;
}
.tabSelectClass {
  padding: 5px 8px;
  margin-right: 3px;

  background-color: rgb(1, 164, 246) !important;
  font-weight: bold;
  font-family: consolas;
  font-size: medium;
  border: solid 1px black;
  border-right: solid 2px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  border-right: solid 2px black;
  box-shadow: 3px 1px 4px black;
  border-bottom: solid 2px black;
  cursor: pointer;
  color: white;
}
.backgroundPopup {
  position: fixed;
  _position: absolute; /* hack for internet explorer 6*/
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: #000000;
  border: 1px solid #cecece;
  z-index: 1;
  opacity: 0.5;
}
.docfileImg {
  height: 50px;
  width: 50px;
}
.popbounce-enter-active {
  animation: popbounce-in 0.5s;
}
.popbounce-leave-active {
  animation: popbounce-in 0.4s reverse;
}
@keyframes popbounce-in {
  0% {
    transform: scale(0);
  }
  25% {
    transform: scale(0.25);
  }
  50% {
    transform: scale(0.5);
  }
  75% {
    transform: scale(0.75);
  }
  100% {
    transform: scale(1);
  }
}
.backgroundPopup {
  position: fixed;
  _position: absolute; /* hack for internet explorer 6*/
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: #000000;
  border: 1px solid #cecece;
  z-index: 1;
  opacity: 0.5;
}
.PopUpCover {
  width: 450px;
  border: solid 1px;
  border-radius: 4px;
  top: 200px;
  position: absolute;
  min-height: 256px;
  right: 450px;
  background-color: rgba(255, 248, 248, 0.86); /*rgb(223, 223, 223);*/
  box-shadow: 1px 1px 20px 1px White;
  border-radius: 18px 18px 18px 18px;
  z-index: 2;
  color: black !important;
}
.PopUpDetail {
  padding: 3px;
  min-height: 200px;
  max-height: 400px;
  overflow: auto;
}
.PopUpHeader {
  padding: 5px !important;
  font-size: 13pt;
  min-height: 30px;
  border-bottom: solid 1px;
}
.PopClose {
  line-height: 18px;
  right: 2px;
  top: 3px;
  position: absolute;
  color: white;
  font-weight: 700;
  display: block;
  padding: 5px;
  background-color: rgba(255, 0, 0, 0.94);
  border-radius: 6px;
  cursor: pointer;
  width: 28px;
  text-align: center;
}
.drop_area {
  height: 60px;
  background-color: antiquewhite;
  margin: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  cursor: pointer;
  text-align: center;
  line-height: 60px;
}
.file_drop {
  font-size: small;
}
.preview_content {
  background-color: lightblue;
  border-radius: 3px;
  margin: 3px;
  min-height: 177px;
  width: 99%;
  overflow: auto;
  padding: 8px;
  border-radius: 1px 1px 20px 20px;
}
.file_column {
  align-content: center;
  text-align: center;
  float: left;
  width: 25%;
  position: relative;
  /* border: solid thin;
                border-radius: 8px; */
  margin-left: 10px;
}
.file_row:after {
  content: "";
  display: table;
  clear: both;
}
.del_img {
  border-radius: 15px;
  cursor: pointer;
  padding: 5px 5px 5px 5px;
  background-color: rgb(255, 0, 0);
  color: White;
  font-weight: bold;
  position: absolute;
  right: -12px;
  z-index: 5001;
}
.del_img:hover {
  background-color: #fb0bbf;
}
.preview_div {
  align-content: center;
  text-align: center;
  height: 100px;
  width: 110px;
  margin: 2px;
  cursor: pointer;
  border: solid thin darkgray;
  border-radius: 10px;
  background-color: rgba(133, 236, 236, 0.15);
}
.percent_div {
  color: #f3dbdb;
  font-weight: bold;
  align-content: center;
  text-align: center;
  width: 100%;
}
.file_preview {
  height: 80px;
  width: 80px;
}
.file_name {
  font-size: 11px;
  text-overflow: ellipsis;
  width: calc(80%);
  display: inline-block;
  /* color: #f3dbdb; */
}
.file_count {
  margin-top: 5px;
  margin-left: 5px;
  vertical-align: middle;
  padding: 0px 3px 3px 3px;
  font-size: small;
  font-weight: bold;
  font-family: Tahoma;
  background-color: rgba(255, 255, 255, 0.41);
  color: Black;
  border: 1px dashed #ccc;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
.error_upload {
  background-color: red;
}
.profileDiv {
  height: 170px;
  width: 180px;
}
.signatureDiv {
  height: 170px;
  width: 300px;
}
.profileImg {
  height: 100%;
  width: 100%;
  border-radius: 10px;
  box-shadow: 5px -4px 5px #807878;
  border-left: solid thin;
  border-bottom: solid thin;
}
.AppHeader {
  border: solid thin gainsboro;
  border-radius: 5px;
  min-height: 55px;
  font-size: medium;
  font-weight: bold;
}
.paymentLabels {
  color: black;
  font-weight: bold;
  font-size: medium;
  text-align: left;
}
.paymentLabels > .Flex_Row {
  border-bottom: solid thin ghostwhite;
}
fieldset {
  margin-bottom: 4px !important;
}
.childSaveTable {
  width: 98%;
  margin-left: 10px;
}
.myhead::-webkit-scrollbar {
  background-color: transparent;
}
.myhead::scrollbar {
  background-color: transparent;
}
.Green {
  background-color: greenyellow;
  display: block;
  font-weight: 600;
}
.appNoClass {
  display: inline-block;
  border: solid thin;
  padding: 5px 5px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  /* font-family: verdana;
                box-shadow: 1px 1px 4px 2px darkgrey;*/
  margin: 0px !important;
  width: 95%;
}
.appNoClass:hover {
  background-color: darkorange;
}
.hidenShowClass {
  display: inline-block;
  border: solid thin;
  padding: 2px 5px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  /* font-family: verdana; */
  -webkit-box-shadow: 1px 1px 4px 2px darkgrey;
  box-shadow: 1px 1px 4px 2px darkgrey;
  right: 34px;
  position: absolute;
}
.hidenShowClass:hover {
  background-color: darkorange;
}
.myIconButton {
  padding: 0px;
}
.myIconButton a.glyphicons:before {
  font-size: 21px;
  cursor: pointer;
}
.Multibutton {
  padding: 0px;
}
.Multibutton a.glyphicons:before {
  font-size: 18px;
  cursor: pointer;
  margin-top: -2px;
  display: block;
}
.blackColor {
  color: black;
}
.redColor {
  color: red;
}
.DropDownHeigh {
  height: 27px;
  line-height: 22px;
}
.RowHeight {
  min-height: 29px;
}
.mandatorySpan {
  text-align: left;
  position: relative;
  display: block;
}
.mandatorySpan.Required:after {
  color: red;
  content: "*";
  position: absolute;
  height: 8px;
  top: -5px;
  font-size: 200%;
}
#divApplication {
  margin-left: 4px;
  margin-right: 5px;
  border: dotted 1px darkgray;
  border-radius: 5px;
  padding: 5px 0px 0px 5px;
}
.slide-fade-enter-active {
  transition: all 0.8s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(200px);
  opacity: 0;
}
.fade-enter-active {
  animation: fade-in 0.4s;
}
.fade-leave-active {
  animation: fade-in 0.4s reverse;
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  5% {
    opacity: 0.05;
  }
  10% {
    opacity: 0.1;
  }
  20% {
    opacity: 0.2;
  }
  25% {
    opacity: 0.25;
  }
  30% {
    opacity: 0.3;
  }
  35% {
    opacity: 0.35;
  }
  40% {
    opacity: 0.4;
  }
  45% {
    opacity: 0.45;
  }
  50% {
    opacity: 0.5;
  }
  55% {
    opacity: 0.55;
  }
  60% {
    opacity: 0.6;
  }
  65% {
    opacity: 0.65;
  }
  70% {
    opacity: 0.7;
  }
  75% {
    opacity: 0.75;
  }
  80% {
    opacity: 0.8;
  }
  85% {
    opacity: 0.85;
  }
  90% {
    opacity: 0.9;
  }
  95% {
    opacity: 0.95;
  }
  100% {
    opacity: 1;
  }
}
.tblEntryForm > .Flex_Row {
  display: flex;
  flex-wrap: wrap;
}
/* .tblEntryForm > .Flex_Row > .Flex_Cell {
            width: 25% !important;
        } */

@media screen and (max-width: 800px) {
  .EntryBlock {
    width: 80%;
  }
  #divApplication {
    display: block;
    height: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .EntryBlock {
    width: 100%;
  }
  fieldset > div {
    width: calc(100vw - 15px);
    overflow: auto;
  }
  .tblEntryForm {
    width: calc(100vw - 35px);
  } /* width 15px less*/
  .tblEntryForm .Flex_Row {
    display: flex;
    flex-wrap: wrap;
  } /* this is responsible for cell wraping*/
  .tblEntryForm .Flex_Row > .Flex_Cell {
    width: 50% !important;
  } /* width of any cell time of screen sizing*/
  .tblEntryForm .Flex_Row > .Flex_Cell_Inline {
    width: 50% !important;
    line-height: 36px;
  } /* width of any cell time of screen sizing*/
  /* Auto calculate the height of the grid div for scrolling when screen size change*/
  .Location {
    max-width: calc(100vw - 30px) !important;
    width: calc(100vw - 40px) !important;
  }
  /*Overflow for horizontal */
  .ekkGrid .GridContent {
    overflow: unset;
  }
  /*then only horizontal scrolling works */
  .Flex_Table.ekkGrid .Flex_Row {
    width: 100%;
  }
}
@media screen and (max-width: 480px) {
  .EntryBlock {
    width: calc(100vw - 35px);
  }
  fieldset > div {
    width: calc(100vw - 35px);
    overflow: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell {
    width: 100% !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell_Inline {
    width: 100% !important;
    line-height: 36px;
  }
  .tblEntryForm .divHR {
    display: block;
  }
  .Flex_Table.ekkGrid.Location {
    max-width: calc(100vw - 40px) !important;
    width: calc(100vw - 40px) !important;
  }
  legend {
    width: calc(100vw - 40px) !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Application.vue